/* EMA free shipping bar live updater + Clarity cart signals. Added 2026-11-03 (Mat t153u).
   Re-renders every [data-ema-fs] container from /cart.js after any cart change on the page, using the same
   rules as snippets/free-shipping-notice.liquid. Threshold basis (dry vs whole cart) comes from data-basis. Never changes the cart. */
/* 2026-11-04 (Mat pt195u): livestock carts show progress towards free Same Day Livestock Airfreight at $500 (data-live-min),
   counted on the whole cart total, same as the checkout rate's price condition. Carts with reef salt can't go by airfreight. */
(function () {
  if (window.__emaFsBar) return; window.__emaFsBar = true;
  var LIVESTOCK = ['anemone', 'coral', 'fish', 'invertebrate', 'live coral', 'marine fish', 'rabbit fish'];
  var SALT = ['red-sea-coral-pro-salt', 'fauna-marin-professional-sea-salt-25kg', 'fauna-marin-professional-sea-salt-20kg', 'red-sea-coral-reef-sea-salt-22kg', 'hiker-ocean-reef-salt', 'blue-treasure-sea-salt-20kg-box', 'red-sea-coral-reef-sea-salt-20kg-box', 'mantis-reef-salt-20kg', 'd-d-h2ocean-classic-pro-reef-salt-23kg', 'premium-saltwater'];
  var FROZEN = ['ema-marine-mega-mix-frozen-fish-food-3', 'ocean-nutrition-red-plankton'];
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var nativeFetch = window.fetch;

  function kind(it) {
    var pt = String(it.product_type || '').toLowerCase().trim();
    if (pt === 'aquarium salt' || SALT.indexOf(it.handle) > -1) return 'salt';
    if (LIVESTOCK.indexOf(pt) > -1) return 'livestock';
    if (pt === 'aquarium food' && String(it.product_title || '').toLowerCase().indexOf('frozen') > -1) return 'frozen';
    if (FROZEN.indexOf(it.handle) > -1) return 'frozen';
    if (pt === 'aquarium system package' || (it.grams || 0) >= 90000) return 'aquarium';
    return 'dry';
  }
  function money(c) { var d = c / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); }
  function clarity() { try { if (typeof window.clarity === 'function') window.clarity.apply(null, arguments); } catch (e) {} }

  function render(cart) {
    var boxes = document.querySelectorAll('[data-ema-fs]');
    var dry = 0, hasDry = false, hasLive = false, hasSalt = false, hasFrozen = false, total = cart.total_price || 0;
    (cart.items || []).forEach(function (it) { var k = kind(it); if (k === 'livestock') hasLive = true; if (k === 'salt') hasSalt = true; if (k === 'frozen') hasFrozen = true; if (k === 'dry') { hasDry = true; dry += it.final_line_price || 0; } });
    var basisEl = document.querySelector('[data-ema-fs][data-basis]');
    if (basisEl && basisEl.getAttribute('data-basis') === 'cart') dry = cart.total_price || 0; // set in free-shipping-notice.liquid
    clarity('set', 'cart_value', (dry / 100).toFixed(2));
    clarity('set', 'cart_total', ((cart.total_price || 0) / 100).toFixed(2));
    boxes.forEach(function (box) {
      var min = parseInt(box.getAttribute('data-min'), 10) || 13000; // $130 since 2026-11-04 (was 10000)
      if (!cart.item_count) { box.innerHTML = ''; return; }
      var left = min - dry, pct = Math.min(100, Math.floor(dry * 100 / min)), html;
      // Previous livestock wording (restore if livestock + dry goods ship together again):
      // 'Your order includes livestock, so it all ships with your livestock by overnight courier or airfreight.'
      // 2026-11-03 Standard Courier rework: dry goods ship free with livestock (earlier line kept for livestock-only carts).
      var liveMin = parseInt(box.getAttribute('data-live-min'), 10) || 50000; // free airfreight on livestock orders from $500 (2026-11-04)
      if (hasLive && hasSalt) { // reef salt can't go by airfreight, so no free airfreight offer
        html = '<div class="ema-fs ema-fs--neutral ema-fs--live" data-dry="' + dry + '"><p class="ema-fs__msg ema-fs__msg--neutral">Your order includes livestock and reef salt, so it ships by overnight courier. Salt can\u2019t go on airfreight.</p><p class="ema-fs__note">Free same-day airfreight on livestock orders from ' + money(liveMin) + ' isn\u2019t available with reef salt.</p></div>';
      } else if (hasLive) { // livestock: progress towards free same-day airfreight on the whole cart total
        var lLeft = liveMin - total, lPct = Math.min(100, Math.floor(total * 100 / liveMin)), notes = [];
        if (hasDry) notes.push('Your dry goods ship free with your livestock.');
        if (hasFrozen) notes.push('Frozen food is still charged.');
        notes.push('Airfreight is airport-to-airport.');
        html = '<div class="ema-fs ema-fs--live' + (lLeft <= 0 ? ' ema-fs--done' : '') + '" data-dry="' + total + '"><p class="ema-fs__msg" aria-live="polite">' +
          (lLeft > 0 ? 'You\u2019re <strong>' + money(lLeft) + '</strong> away from free same-day airfreight on your livestock order'
                     : '<span class="ema-fs__tick" aria-hidden="true">&#10003;</span> You\u2019ve got free same-day airfreight') +
          '</p><div class="ema-fs__track" role="progressbar" aria-label="Progress towards free same-day airfreight" aria-valuemin="0" aria-valuemax="' + (liveMin / 100) +
          '" aria-valuenow="' + (Math.min(total, liveMin) / 100).toFixed(2) + '" aria-valuetext="' + money(total) + ' of ' + money(liveMin) + '"><span class="ema-fs__fill" style="width: ' + lPct + '%"></span></div>' +
          '<p class="ema-fs__note">' + notes.join(' ') + '</p></div>';
      } else if (!hasDry) {
        html = '<div class="ema-fs ema-fs--neutral" data-dry="0"><p class="ema-fs__msg ema-fs__msg--neutral">Free shipping applies to dry goods orders over ' + money(min) + '.</p></div>';
      } else {
        html = '<div class="ema-fs' + (left <= 0 ? ' ema-fs--done' : '') + '" data-dry="' + dry + '"><p class="ema-fs__msg" aria-live="polite">' +
          (left > 0 ? 'You\u2019re <strong>' + money(left) + '</strong> away from free shipping on dry goods'
                    : '<span class="ema-fs__tick" aria-hidden="true">&#10003;</span> You\u2019ve got free shipping on your dry goods') +
          '</p><div class="ema-fs__track" role="progressbar" aria-label="Progress towards free shipping on dry goods" aria-valuemin="0" aria-valuemax="' + (min / 100) +
          '" aria-valuenow="' + (Math.min(dry, min) / 100).toFixed(2) + '" aria-valuetext="' + money(dry) + ' of ' + money(min) + '"><span class="ema-fs__fill" style="width: ' + pct + '%"></span></div>' +
          '<p class="ema-fs__note">Livestock, frozen food and reef salt are charged separately.</p></div>';
      }
      if (box.innerHTML.trim() !== html) box.innerHTML = html;
    });
  }

  var timer = null;
  function refresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      nativeFetch.call(window, (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) render(c); })
        .catch(function () {});
    }, delay == null ? 250 : delay);
  }
  window.emaFreeShippingRefresh = refresh;

  var lastAdd = 0;
  function noteAdd() { var n = Date.now(); if (n - lastAdd > 1500) { lastAdd = n; clarity('event', 'add_to_cart'); } }

  // Watch cart writes made by any script (theme, upsell, cart automation). Responses are passed through untouched.
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_RE.test(url)) {
          p.then(function (r) { if (r && r.ok && ADD_RE.test(url)) noteAdd(); refresh(); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    try {
      if (CART_RE.test(String(url))) {
        var isAdd = ADD_RE.test(String(url));
        this.addEventListener('load', function () { if (isAdd && this.status >= 200 && this.status < 300) noteAdd(); refresh(); });
      }
    } catch (e) {}
    return xo.apply(this, arguments);
  };
  document.addEventListener('on:cart:add', function () { noteAdd(); refresh(); });
  document.addEventListener('on:line-item:change', function () { refresh(); });
  document.addEventListener('on:cart-drawer:after-open', function () { refresh(0); });

  function init() { if (document.querySelector('[data-ema-fs]') || typeof window.clarity === 'function') refresh(0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
